import { isNullOrUndefined } from 'intact-shared';
export function request(options) {
  var xhr = new XMLHttpRequest();
  var formData = new FormData();
  var data = options.data;
  if (data) {
    for (var key in data) {
      if (!isNullOrUndefined(data[key])) {
        formData.append(key, data[key]);
      }
    }
  }
  var upload = xhr.upload;
  if (upload) {
    upload.onprogress = function (e) {
      var percent = 0;
      if (e.total > 0) {
        percent = Math.floor(e.loaded / e.total * 100);
      }
      options.onProgress(e, percent, xhr);
    };
  }
  xhr.onerror = function (e) {
    return options.onError(getError(options, xhr), xhr);
  };
  xhr.onload = function () {
    if (xhr.status < 200 || xhr.status >= 300) {
      return options.onError(getError(options, xhr), xhr);
    }
    options.onSuccess(getBody(xhr), xhr);
  };
  xhr.open('post', options.action || '', true);
  if (options.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }
  var headers = options.headers;
  if (headers) {
    for (var _key in headers) {
      var value = headers[_key];
      if (!isNullOrUndefined(value)) {
        xhr.setRequestHeader(_key, value);
      }
    }
  }
  xhr.send(formData);
  return {
    abort: function abort() {
      xhr.abort();
    }
  };
}
function getError(options, xhr) {
  var msg = "cannot post " + options.action + " " + xhr.status + "'";
  var err = new Error(msg);
  err.status = xhr.status;
  err.method = 'post';
  err.url = options.action || '';
  err.response = getBody(xhr);
  err.xhr = xhr;
  return err;
}
function getBody(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) return text;
  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}